<template>
    <div class="scene-list">
        <SceneItem v-for="(item, index) in sceneData" :key="index" :data="item" @sceneClick="sceneClick" :level="index" />
    </div>
</template>

<script>
import SceneItem from "./SceneItem";
import i18n from "@/i18n";
import { getTreesData } from "@/views/zhiji/js/services/service.js";

export default {
    name: "SceneList",
    props: ["startDate", "endDate", "quesType", "channelType", "langType", "order"],
    components: {
        SceneItem,
    },
    data() {
        return {
            activeSceneData: [],
            treeData: [],
            sceneData: {
                "1": [],
                "2": [],
                "3": []
            },
        }
    },
    created() {
        const _this = this;
        getTreesData().then(function(dataList) {
            let treeData = {
                label: i18n.t("zhiji.common.allClassify"),
                id: "-1",
                smallLabel: "",
                children: dataList,
            };
            _this.treeData = treeData
            _this.sceneData["1"] = treeData.children;
        });
    },
    methods: {
        sceneClick(data) {
            let level = parseInt(data.level);
            let item = data.item;
            let nextLevel = String(level + 1);

            if (item.id === "all") {
                if (nextLevel === "2") {
                    this.sceneData["3"] = [];
                    this.$emit("sceneItemClick", "");
                } else {
                    let lastSenceId = this.activeSceneData[level - 2].id;
                    this.$emit("sceneItemClick", lastSenceId);
                }
            } else {
                this.activeSceneData[level - 1] = item;
                this.$emit("sceneItemClick", item.id);
            }

            this.sceneData[nextLevel] = [];
            if (item.children && item.children.length > 0) {
                this.sceneData[nextLevel] = item.children;
            }
        },
    }
}
</script>
